import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Spinner } from "react-bootstrap";

const Loading: React.FC<IProps> = ({
  // destructure props here if needed
}: IProps) => {
  return (
    <S.Wrapper>
      <Spinner animation="grow" size="sm" />
    </S.Wrapper>
  )
};

export { Loading }